import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-orgsetup',
  templateUrl: './orgsetup.component.html',
  styleUrls: ['./orgsetup.component.css']
})
export class OrgsetupComponent {

  constructor(private router: Router) {}

  cards = [
    { no:'1',title: 'Entities', description: 'Create Entities within Client Groups and put Entity initials.' },
    { no:'2',title: 'Vertical', description: 'Create the Vertical for which you want to monitor compliances.' },
    { no:'3',title: 'Locations', description: 'Create Location names for your organisation as well as for your Clients. Eg. Delhi, Gurugram etc.' },
    { no:'4',title: 'Departments', description: 'Create Department names for your organization. Eg. Secretarial, Legal, Tax, Audit etc.' },
    { no:'5',title: 'Users', description: 'Create Users for your Firm (full access) as well as your Clients (view only).' },
    { no:'6',title: 'Go Live (Already Live)', description: 'You are now ready to use Complinity. Do not forget to set-up module masters. Please click on "Home" button to go to your default home page' },
  ];

  navigateToMaster(cardTitle: string) {
    if(cardTitle=="Entities"){
      this.router.navigate(['entity']); 
    }else if(cardTitle=="Vertical"){
      this.router.navigate(['vertical']); 
    }else if(cardTitle=="Locations"){
      this.router.navigate(['location']); 
    }else if(cardTitle=="Departments"){
      this.router.navigate(['department']); 
    }else if(cardTitle=="Users"){
      this.router.navigate(['user']); 
    }else {
      this.router.navigate(['department']); 
    }

  }

}
